export const RESOURCES = {
  energy: {
    id: 'energy',
    name: 'Typing Energy',
    color: 'yellow'
  },
  currency: {
    id: 'wordCoins',
    name: 'Word Coins',
    color: 'gold'
  },
  premiumCurrency: {
    id: 'letterGems',
    name: 'Letter Gems',
    color: 'purple'
  }
};
